import React from "react";
import { Box, Typography, Select, MenuItem } from "@mui/material";

const Dataset = ({
  selectedProject,
  datasets,
  dropdown2Value,
  handleDropdown2Change,
}) => {
  const handleValue = () => {
    if (selectedProject) {
      if (dropdown2Value) {
        return dropdown2Value;
      }
      return "You can select a form now.";
    }
    return "Select a Projects first.";
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <Box
          sx={{
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: dropdown2Value ? "green" : "gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
          }}
        >
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", color: "white" }}
          >
            2
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
          Select Dataset
        </Typography>
      </Box>
      <Select
        defaultValue={handleValue()}
        value={dropdown2Value}
        onChange={handleDropdown2Change}
        sx={{ marginBottom: 6, width: "100%" }}
        disabled={!selectedProject}
      >
        {datasets?.map((dataset) => (
          <MenuItem
            key={dataset.id}
            selected={dataset.name === dropdown2Value}
            value={dataset}
          >
            {dataset.name}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default Dataset;
